import { Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useMatch, useResolvedPath } from 'react-router-dom';

export function CustomLink({ children, to }) {
    const resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });

    return (
        <Link
            component={RouterLink}
            underline="none"
            to={to}
            sx={{
                padding: '8px 12px',
                fontWeight: 500,
                fontSize: '0.95rem',
                color: match ? '#2563eb' : '#64748b',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    color: '#2563eb',
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                },
            }}
        >
            {children}
        </Link>
    );
}